/**
 * Client-side JavaScript: Interactions
 *
 * Event delegation, theme management, lightbox, and filter drawer
 * for the HTML report.
 * Uses event delegation (document-level listeners) instead of inline handlers.
 */

export const JS_INTERACTIONS = `
  /* ── Event Delegation ── */
  document.addEventListener('click',function(e){
    var target=e.target;

    /* Test row click → open drawer */
    var row=target.closest('.test-row');
    if(row){openDrawer(row.getAttribute('data-testid'));return;}

    /* Filter chip (multi-dimensional) */
    var chip=target.closest('.filter-chip');
    if(chip){
      var dim=chip.getAttribute('data-dimension');
      var val=chip.getAttribute('data-value');
      if(dim&&val)toggleFilter(dim,val);
      return;
    }

    /* Clear all filters */
    if(target.closest('.filter-clear')){clearAllFilters();return;}

    /* Filter icon → open filter drawer */
    if(target.closest('.filter-icon-btn')){openFilterDrawer();return;}

    /* Filter drawer close */
    if(target.closest('#filter-drawer-close')){closeFilterDrawer();return;}
    if(target.closest('#filter-drawer-backdrop')){closeFilterDrawer();return;}

    /* Step header → expand/collapse */
    var stepH=target.closest('[data-step]');
    if(stepH){var sd=document.getElementById('step-detail-'+stepH.getAttribute('data-step'));if(sd)sd.classList.toggle('show');return;}

    /* Screenshot → lightbox */
    if(target.classList.contains('artifact-thumb')||target.classList.contains('artifact-col-img')){openLightbox(target.src);return;}

    /* Segmented control switch */
    var segBtn=target.closest('.seg-btn');
    if(segBtn){
      var group=segBtn.parentElement;
      if(group&&group.classList.contains('seg-ctrl')){
        var col=group.parentElement;
        var btns=group.querySelectorAll('.seg-btn');
        for(var bi=0;bi<btns.length;bi++)btns[bi].classList.remove('active');
        segBtn.classList.add('active');
        var panes=col.querySelectorAll('.seg-pane');
        for(var pi=0;pi<panes.length;pi++){panes[pi].classList.remove('active');var vid=panes[pi].querySelector('video');if(vid)vid.pause();}
        var tp=col.querySelector('[data-seg-pane="'+segBtn.getAttribute('data-seg')+'"]');
        if(tp)tp.classList.add('active');
      }
      return;
    }

    /* Network DevTools: request row → expand/collapse detail */
    var ndtRow=target.closest('.ndt-row');
    if(ndtRow){
      /* Virtual lists handle their own click events */
      var vlist=ndtRow.closest('.ndt-vlist');
      if(vlist)return;
      var idx=ndtRow.getAttribute('data-ndt-idx');
      var det=document.getElementById('ndt-d-'+idx);
      if(det){
        var isOpen=det.classList.toggle('show');
        ndtRow.classList.toggle('ndt-row--open',isOpen);
        /* Close other open details */
        var list=ndtRow.parentElement;
        if(list){var others=list.querySelectorAll('.ndt-detail.show');for(var oi=0;oi<others.length;oi++){if(others[oi]!==det){others[oi].classList.remove('show');var pr=others[oi].previousElementSibling;if(pr)pr.classList.remove('ndt-row--open');}}}
      }
      return;
    }

    /* Network DevTools: detail tab switch */
    var ndtTab=target.closest('.ndt-detail-tab');
    if(ndtTab){
      var tgt=ndtTab.getAttribute('data-ndt-target');
      var pane=ndtTab.getAttribute('data-ndt-tab');
      var det=document.getElementById(tgt);
      if(det){
        var tabs=det.querySelectorAll('.ndt-detail-tab');
        for(var ti=0;ti<tabs.length;ti++)tabs[ti].classList.remove('active');
        ndtTab.classList.add('active');
        var panes=det.querySelectorAll('.ndt-detail-pane');
        for(var pi=0;pi<panes.length;pi++)panes[pi].classList.remove('active');
        var tp=det.querySelector('[data-ndt-pane="'+pane+'"]');
        if(tp)tp.classList.add('active');
      }
      return;
    }

    /* Network DevTools: type filter */
    var ndtFilterBtn=target.closest('.ndt-filter-btn');
    if(ndtFilterBtn){
      var filterType=ndtFilterBtn.getAttribute('data-ndt-filter');
      var toolbar=ndtFilterBtn.closest('.ndt-toolbar');
      if(toolbar){
        var btns=toolbar.querySelectorAll('.ndt-filter-btn');
        for(var bi=0;bi<btns.length;bi++)btns[bi].classList.remove('active');
        ndtFilterBtn.classList.add('active');
        var ndt=toolbar.closest('.ndt');
        if(ndt){ndtApplyFilters(ndt,filterType,null);}
      }
      return;
    }

    /* Console log level filter */
    var consoleFilterBtn=target.closest('.console-filter-btn');
    if(consoleFilterBtn){
      var toolbar=consoleFilterBtn.closest('.console-toolbar');
      if(toolbar){
        var btns=toolbar.querySelectorAll('.console-filter-btn');
        for(var bi=0;bi<btns.length;bi++)btns[bi].classList.remove('active');
        consoleFilterBtn.classList.add('active');
        var filterLevel=consoleFilterBtn.getAttribute('data-console-filter');
        var panel=consoleFilterBtn.closest('.console-panel');
        /* Use virtual filter if available */
        if(panel&&panel.__conFilter){panel.__conFilter(filterLevel);return;}
        var list=panel?panel.querySelector('.console-list'):null;
        if(list){
          var entries=list.querySelectorAll('.console-entry');
          for(var ei=0;ei<entries.length;ei++){
            if(filterLevel==='all'){entries[ei].style.display='';}
            else{entries[ei].style.display=entries[ei].getAttribute('data-console-level')===filterLevel?'':'none';}
          }
        }
      }
      return;
    }

    /* Action step click → seek video + highlight */
    var actionStep=target.closest('.action-step.seekable');
    if(actionStep){
      var offset=parseFloat(actionStep.getAttribute('data-offset'));
      if(!isNaN(offset)){
        var video=document.querySelector('.drawer-body video');
        if(video){video.currentTime=offset;video.play();}
        /* Clear previous active and highlight clicked */
        var prev=document.querySelectorAll('.action-active');
        for(var ai=0;ai<prev.length;ai++)prev[ai].classList.remove('action-active');
        actionStep.classList.add('action-active');
        actionStep.classList.add('seeking');
        setTimeout(function(){actionStep.classList.remove('seeking');},400);
      }
      return;
    }

    /* Stack trace toggle */
    if(target.classList.contains('stack-toggle-btn')){var se=document.getElementById(target.getAttribute('data-stack'));if(se){var sv=se.classList.toggle('show');target.textContent=sv?'Hide stack trace':'Show stack trace';}return;}

    /* Lightbox close */
    if(target.classList.contains('lightbox-overlay')||target.classList.contains('lightbox-close')){closeLightbox();return;}

    /* Theme toggle */
    var themeBtn=target.closest('.theme-btn');
    if(themeBtn){setTheme(themeBtn.getAttribute('data-theme-val'));return;}

    /* Drawer close */
    if(target.closest('#drawer-close')){closeDrawer();return;}
    if(target.closest('#drawer-backdrop')){closeDrawer();return;}
  });

  /* Search input — main test search + network filter search */
  document.addEventListener('input',function(e){
    if(e.target.id==='search-input')doSearch(e.target.value);
    if(e.target.hasAttribute('data-ndt-search')){
      var ndt=e.target.closest('.ndt');
      if(ndt){
        var activeBtn=ndt.querySelector('.ndt-filter-btn.active');
        var filterType=activeBtn?activeBtn.getAttribute('data-ndt-filter'):'all';
        ndtApplyFilters(ndt,filterType,e.target.value);
      }
    }
  });

  /* Keyboard */
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){closeLightbox();closeDrawer();closeFilterDrawer();}
  });

  /* ── Theme Management ── */
  function getThemePref(){return localStorage.getItem('tr-theme')||'system'}
  function resolveTheme(pref){return pref==='system'?(window.matchMedia('(prefers-color-scheme:light)').matches?'light':'dark'):pref}
  function applyTheme(){
    var pref=getThemePref();
    document.documentElement.setAttribute('data-theme',resolveTheme(pref));
    var btns=document.querySelectorAll('.theme-btn');
    for(var i=0;i<btns.length;i++){btns[i].classList.toggle('active',btns[i].getAttribute('data-theme-val')===pref);}
  }
  function setTheme(pref){localStorage.setItem('tr-theme',pref);applyTheme();}
  try{window.matchMedia('(prefers-color-scheme:light)').addEventListener('change',function(){if(getThemePref()==='system')applyTheme();});}catch(e){}

  /* ── Lightbox ── */
  function openLightbox(src){
    var o=document.createElement('div');o.className='lightbox-overlay';
    o.innerHTML='<img src="'+src.replace(/"/g,'&quot;')+'" alt="Screenshot">';
    var b=document.createElement('button');b.className='lightbox-close';b.innerHTML='&times;';
    document.body.appendChild(o);document.body.appendChild(b);
  }
  function closeLightbox(){
    var o=document.querySelector('.lightbox-overlay');if(o)o.remove();
    var b=document.querySelector('.lightbox-close');if(b)b.remove();
  }

  /* ── Video ↔ All Panels Sync ── */
  var _videoSyncCleanup=null;
  function syncActionsWithVideo(){
    /* Clean up previous listener */
    if(_videoSyncCleanup){_videoSyncCleanup();_videoSyncCleanup=null;}
    var video=document.querySelector('.drawer-body video');
    if(!video)return;

    /* Action steps sync */
    var steps=document.querySelectorAll('.action-step.seekable');
    var offsets=[];
    for(var i=0;i<steps.length;i++){
      var o=parseFloat(steps[i].getAttribute('data-offset'));
      if(!isNaN(o))offsets.push({el:steps[i],offset:o});
    }
    offsets.sort(function(a,b){return a.offset-b.offset;});

    /* Collect console and network panels with video sync */
    var consolePanels=document.querySelectorAll('.console-panel');
    var ndtPanels=document.querySelectorAll('.ndt');

    var lastActive=null;
    function onTimeUpdate(){
      var ct=video.currentTime;

      /* Sync action steps */
      if(offsets.length){
        var match=null;
        for(var i=offsets.length-1;i>=0;i--){
          if(offsets[i].offset<=ct){match=offsets[i].el;break;}
        }
        if(match!==lastActive){
          if(lastActive)lastActive.classList.remove('action-active');
          if(match){
            match.classList.add('action-active');
            match.scrollIntoView({block:'nearest',behavior:'smooth'});
          }
          lastActive=match;
        }
      }

      /* Sync console panels */
      for(var ci=0;ci<consolePanels.length;ci++){
        if(consolePanels[ci].__videoSync)consolePanels[ci].__videoSync(ct);
      }

      /* Sync network panels */
      for(var ni=0;ni<ndtPanels.length;ni++){
        if(ndtPanels[ni].__videoSync)ndtPanels[ni].__videoSync(ct);
      }
    }
    video.addEventListener('timeupdate',onTimeUpdate);
    video.addEventListener('seeked',onTimeUpdate);
    _videoSyncCleanup=function(){
      video.removeEventListener('timeupdate',onTimeUpdate);
      video.removeEventListener('seeked',onTimeUpdate);
      if(lastActive)lastActive.classList.remove('action-active');
    };
  }

  /* ── Filter Drawer ── */
  function openFilterDrawer(){
    var d=document.getElementById('filter-drawer');if(d)d.classList.add('open');
    var b=document.getElementById('filter-drawer-backdrop');if(b)b.classList.add('open');
  }
  function closeFilterDrawer(){
    var d=document.getElementById('filter-drawer');if(d)d.classList.remove('open');
    var b=document.getElementById('filter-drawer-backdrop');if(b)b.classList.remove('open');
  }
`;
